module.exports = __webpack_public_path__ + "static/media/Cheque.b4fbb545.svg";